<template>
  <div id="app">
    <router-view />
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
:root {
  --mantine-z-index-app: 100;
    --mantine-z-index-modal: 200;
    --mantine-z-index-popover: 300;
    --mantine-z-index-overlay: 400;
    --mantine-z-index-max: 9999;
    --mantine-scale: 1;
    --mantine-cursor-type: default;
    --mantine-webkit-font-smoothing: antialiased;
    --mantine-color-scheme: light dark;
    --mantine-moz-font-smoothing: grayscale;
    --mantine-color-white: #fff;
    --mantine-color-black: #000;
    --mantine-line-height: 1.55;
    --mantine-font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
    --mantine-font-family-monospace: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
    --mantine-font-family-headings: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
    --mantine-heading-font-weight: 700;
    --mantine-radius-default: calc(.25rem* var(--mantine-scale));
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-family: var(--mantine-font-family);
  font-size: var(--mantine-font-size-md);
}
</style>



// WEBPACK FOOTER //
// src/App.vue